<template>
    <div class="timesheet-copy-names">
        <b-button size="sm" variant="outline-primary" :disabled="busy || !names.length" @click="copy">
            <i class="far fa-copy mr-1" aria-hidden="true"></i>Скопировать ФИО
        </b-button>
        <small role="status">{{ message }}</small>
        <b-form-textarea v-if="fallback" :value="fallback" readonly rows="4"
            aria-label="ФИО для копирования" @focus="$event.target.select()" />
    </div>
</template>
<script>
export default {
    name: 'TimesheetCopyNames',
    props: {names: {type: Array, default: () => []}},
    data: () => ({busy: false, message: '', fallback: ''}),
    computed: {text() { return this.names.join('\n'); }},
    watch: {text() { this.message = ''; this.fallback = ''; }},
    methods: {
        async copy() {
            const text = this.text, count = this.names.length;
            if (!count || this.busy) return;
            this.busy = true; this.message = ''; this.fallback = '';
            try {
                await navigator.clipboard.writeText(text);
                if (this.text === text) this.message = `Скопировано: ${count}`;
            } catch (_) {
                if (this.text === text) {
                    this.fallback = text;
                    this.message = 'Выделите и скопируйте список ниже.';
                }
            } finally { this.busy = false; }
        }
    }
};
</script>
<style scoped>
.timesheet-copy-names {display: flex; flex-wrap: wrap; align-items: center; gap: .4rem; min-width: 0;}
.timesheet-copy-names small {color: #466379;}
.timesheet-copy-names textarea {flex-basis: 100%;}
</style>
